export class userPortraits {
  constructor(difference) {
    this.createBlockTimes = 0
    this.styleName = "1"
    this.name = "超星头像"
    this.innerElement = "layoutComponent"
    this.thumbnail = require("../../assets/images/leftMenu/layout/layout_1.png")
    this.width = 120
    this.height = 36
    this.top = 10
    this.left = 10
    this.moduleId = ""
    this.appId = ""
    this.isCache = true
    this.isShowTabs = false
    this.isShowTitle = false
    this.isShowMoreBtn = false
    this.disableSetColAndRow = true
    this.disableCancleGroup = true
    this.activeIndex = 0
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderStyle = "solid" // solid dashed dotted
    this.borderColor = "#000000"
    this.borderWidth = 0
    this.boxShadowColor = "rgba(96,100,106,1)"
    this.boxShadowH = 0
    this.boxShadowV = 0
    this.boxShadowBlur = 0
    this.boxShadowSpread = 0
    this.clipSize = "cover"
    this.repeatType = "no-repeat"
    this.alignType = "center center"
    this.imgSrc = ""
    this.opacity = 100
    this.noCacheComponent = false
    this.updateTimer = 100
    this.reverseGetColsUid = false
    this.titleOptions = [
      {
        type: "top",
        elementOptions: []
      },
      {
        type: "bottom",
        elementOptions: []
      },
      {
        type: "left",
        elementOptions: []
      },
      {
        type: "right",
        elementOptions: []
      }
    ]
    this.rows = [
      {
        height: "100%",
        alginH: "center", //水平对齐，start左对齐，center居中对齐，around分散对齐，between两端对齐
        cols: [
          //width加起来不能大于12
          {
            uid: "emptyLayoutComponentRootBox",
            alignSelf: "stretch",
            width: "100%",
            component: null,
            disableSetColAndRow: true,
            disableSetData: true,
            elementOptions: [
              {
                width: 36,
                height: 36,
                top: 0,
                left: 0,
                isUserInfo: true,
                disableSetData: true,
                elementInLayoutId: 0,
                innerElement: "imageComponent",
                shapeType: "round", // square， radius， round
                shapeChecked: true,
                borderChecked: false,
                borderShadowChecked: false,
                rotateChecked: false,
                borderRadius:"50%",
                borderTypeFlag: 2, //圆角的类型 分为1四个角可以单独设置 2四个角一致
                borderTopLeftRadius: "50%",
                borderTopRightRadius: "50%",
                borderBottomLeftRadius: "50%",
                borderBottomRightRadius: "50%",
                borderStyle: "solid", // solid dashed dotted
                borderColor: "#000000",
                borderWidth: 0,
                borderIsThemeColor: false,
                boxShadowColor: ["rgba(255,255,255,1)"],
                boxShadowH: 0,
                boxShadowV: 0,
                boxShadowBlur: 0,
                boxShadowSpread: 0,
                rotate: 0,
                clipSize: "cover",
                repeatType: "no-repeat",
                alignType: "center center",
                imgSrc: "",
                opacity: 100,
                hoverZoomLevel: 1,
                openBlankPage: true,
                linkUrl: "",
                accessRulers: [],
                imgName: "正方形"
              },
              {
                width: 42,
                height: 20,
                top: 8,
                left: 46,
                isUserInfo: true,
                disableSetData: true,
                elementInLayoutId: 1,
                textType: "title",
                innerElement: "cxText",
                content: "",
                textLimitLines: 1,
                openBlankPage: true,
                linkUrl: "",
                accessRulers: [],
                fontFamily: "sans-serif",
                lineHeight: 20,
                fontSize: 14,
                fontWeight: "400",
                bgColor: "rgba(255,255,255,0)",
                color: "rgba(0, 0, 0, 0.8)",
                textIsThemeColor: false,
                hoverTextIsThemeColor: false,
                colorType: "纯色",
                startColor: "rgba(0, 0, 0, 0.8)",
                endColor: "rgba(0, 0, 0, 0.8)",
                colorlinearGradientAngle: 90,
                bgType: "自定义",
                letterSpacing: 0,
                fontStyle: "normal",
                textAlign: "left",
                writingMode: "horizontal-tb",
                rotate: 0,
                hoverFontFamily: "default",
                textDecoration: "none",
                textIndent: 0,
                padding: 0,
                paddingTop: 0,
                paddingRight: 0,
                paddingLeft: 0,
                paddingBottom: 0,
                borderTypeFlag: 2,
                borderRadius: 0,
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderStyle: "solid", // solid dashed dotted
                borderColor: "#000000",
                borderWidth: 0,
                borderIsThemeColor: false,
                textOverFlowType: "visible",
                // 透明度
                opacity: 100,
                // 阴影
                boxShadowColor: ["rgba(255,255,255,1)"],
                boxShadowH: [0],
                boxShadowV: [0],
                boxShadowBlur: [0],
                boxShadowSpread: [0],
                background: []
              }
            ],
            componentBoxOptions: {
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 0,
              paddingRight: 0,
              borderStyle: "dashed", // solid, dashed, dotted
              borderColor: "#000000",
              borderWidth: 0,
              clipSize: "cover",
              repeatType: "no-repeat",
              alignType: "center center",
              imgSrc: "",
              opacity: 100,
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              // animateSets: {
              //   animateType: 0,
              //   animateDirection: "无",
              //   animateDuration: 1.5,
              //   animateDelay: 0,
              //   hasDirection: false,
              //   animateTriggerNumType: "单次触发",
              //   animateClass: "",
              //   executionAnimateClass: ""
              // }
            }
          }
        ]
      }
    ]
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
